import ApiService from "../../api/api";

export default {
    namespaced: true,
    state() {
        return {
            pages: null,
            historical_status_id: null,
        };
    },
    getters: {
        pages(state) {
            return state.pages;
        },
        historicalStatusId(state) {
            return state.historical_status_id;
        },
    },
    mutations: {
        setPages(state, value) {
            state.pages = value;
        },
        setHistoricalStatusId(state, value) {
            state.historical_status_id = value;
        },
    },
    actions: {
        getPages({commit, state}, page = 1) {
            return new Promise((resolve, reject) => {
                ApiService.get('/archive?page=' + page, {
                    historical_status_id: state.historical_status_id
                }).then(response => {
                    commit('setPages', response.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });

        },
    },
}
